import { getFirestore, doc, setDoc, updateDoc } from "firebase/firestore";

import Document from "../general/document";
import Invitation from "./invitation";

export interface EmployeeData {
  employeeId: string;
  name: string;
  extra?: {
    client_selection: string;
  };
}

class Employee extends Document<EmployeeData> {
  private _invitation?: Invitation;

  get id() {
    return this.data.employeeId;
  }
  get name() {
    return this.data.name;
  }
  get allClients() {
    return (
      !this.data.extra?.client_selection ||
      this.data.extra?.client_selection === "ALL"
    );
  }
  set allClients(value: boolean) {
    updateDoc(this.ref!, {
      extra: { client_selection: value ? "ALL" : "SELECT" },
    });
  }
  get invitation() {
    if (!this._invitation) {
      this._invitation = new Invitation(
        `${this.path}/invitation/0`,
        {},
        this.store
      );
    }
    return this._invitation.code ? this._invitation : undefined;
  }
  get inivitationStatus() {
    return this.invitation?.status || "inactive";
  }

  async invite() {
    const code = this.invitationCode();
    const data = {
      code,
      createdAt: new Date(),
    };
    const firestore = getFirestore();
    await setDoc(doc(firestore, `${this.path}/invitation/0`), data);
  }

  private invitationCode = () => {
    let result = "";
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    for (let i = 0; i < 6; i++) {
      result += characters.charAt(
        Math.floor(Math.random() * characters.length)
      );
    }
    return result;
  };
}

export default Employee;
